import { useLocation } from 'react-router-dom';
import { ClientQuestBand } from './QuestBand';

/**
 * WHERE the band lives in this app (Nick, 2026-09-01): every arthelper.ai page —
 * except the welcome wizard (its own moment) and the /admin working surfaces.
 */
export function ClientQuestBandGate() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/welcome') || pathname.startsWith('/admin')) return null;
  return <ClientQuestBand />;
}
